// extracted by mini-css-extract-plugin
export var container = "footer-module--container--HXu2X";
export var links = "footer-module--links--3GubR";
export var mobileLinks = "footer-module--mobileLinks--1qZIA";
export var socialicon = "footer-module--socialicon--2VL8V";
export var socialmedia = "footer-module--socialmedia--1JInS";